<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import "../api/api";
import PrizePoolTable from "./prize-pool-table.svelte";
export let race;
export let raceId = undefined;
export let inGame = true;
$: useFlatNeutral = $stateUi.games?.useFlatNeutralRaceCard ?? false;
</script>

<InfoCard
	width="100%"
	customStylesCard={useFlatNeutral
		? 'background: var(--color-background-500); border: 1px solid var(--color-neutral-900);'
		: 'background-image: linear-gradient(180deg, var(--color-neutral-500) 0%, var(--color-background-100) 100%), linear-gradient(to top, var(--color-neutral-900) 0%, var(--color-neutral-900) 58%, rgba(255, 255, 255, 0.22) 100%);'}
>
	<Text
		type="subtitle"
		subtitleSize="large"
		subtitleWeight="bold"
		customStyle="margin-bottom: 1rem;"
	>
		{$t(Verbiage.race_leaderboard)}</Text
	>
	<PrizePoolTable {race} {raceId} {inGame} />

	<div class="race-links">
		<div>
			{#if race?.lastRaceId}
				{#if raceId === 'current'}
					&lt;&lt; <a href={toSiteUrl(`/races/last`, $loggedIn)}>Last Race</a>
				{:else if raceId === 'next'}
					&lt;&lt; <a href={toSiteUrl(`/races/current`, $loggedIn)}>Last Race</a>
				{:else}
					&lt;&lt; <a href={toSiteUrl(`/races/${race?.lastRaceId}`, $loggedIn)}>Last Race</a>
				{/if}
			{/if}
		</div>
		<div>
			{#if race?.nextRaceId}
				{#if raceId === 'current'}
					<a href={toSiteUrl(`/races/next`, $loggedIn)}>Next Race</a> &gt;&gt;
				{:else if raceId === 'last'}
					<a href={toSiteUrl(`/races/current`, $loggedIn)}>Next Race</a> &gt;&gt;
				{:else}
					<a href={toSiteUrl(`/races/${race?.nextRaceId}`, $loggedIn)}>Next Race</a> &gt;&gt;
				{/if}
			{/if}
		</div>
	</div>
</InfoCard>

<style>
	.race-links {
    display: flex;
    justify-content: space-between
}
</style>
